import { render, staticRenderFns } from "./AllCheck.vue?vue&type=template&id=d85c2ace&scoped=true"
import script from "./AllCheck.vue?vue&type=script&lang=js"
export * from "./AllCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85c2ace",
  null
  
)

export default component.exports